import { render, staticRenderFns } from "./FriendsLocConfig.vue?vue&type=template&id=1624014f&scoped=true&lang=pug"
import script from "./FriendsLocConfig.vue?vue&type=script&lang=js"
export * from "./FriendsLocConfig.vue?vue&type=script&lang=js"
import style0 from "./FriendsLocConfig.vue?vue&type=style&index=0&id=1624014f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1624014f",
  null
  
)

export default component.exports